export class ProductRestrictionRouteCommandModel {
    public productRestrictionRouteId:string;
    public originLocationId:string;   
    public destinationLocationId:string;    
    public excludeFlag:boolean;     
    public displaySequence: number; 
}